import { gsap, Power2, Linear } from 'gsap'
import { ScrollTrigger }        from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function isMobile(){
	return (innerWidth < 1240)
}

document.querySelectorAll('section[data-presentation]').forEach(section =>
{
	section.querySelectorAll('.text, .citation, h1, figure').forEach(el =>
	{
		el.classList.add('reveal')
	})
	
	section.querySelector('figure').dataset.reveal_from = 'left'
	section.querySelector('h1').dataset.reveal_from = 'bottom'
	section.querySelector('h1').dataset.reveal_delay = '0.08'
	section.querySelector('.text').dataset.reveal_from = 'bottom'
	section.querySelector('.text').dataset.reveal_delay = '0.16'
	section.querySelector('.citation').dataset.reveal_from = 'bottom'
	section.querySelector('.citation').dataset.reveal_delay = '0.24'
})

document.querySelectorAll('section[data-univers]').forEach(section =>
{
	section.querySelectorAll('figure, section, h2, h3, .text, .scroll, .button').forEach(el =>
	{
		el.classList.add('reveal')
	})
	
	if (section.dataset.Align === 'right')
	{
		section.querySelector('figure').dataset.reveal_from = 'right'
		section.querySelector('.text').dataset.reveal_from = 'left'
		section.querySelector('.text').dataset.reveal_delay = '0.08'
		
		if (section.querySelector('section'))
		{
			section.querySelector('section').dataset.reveal_from = 'left'
		}
		
		if (section.querySelector('h2'))
		{
			section.querySelector('h2').dataset.reveal_from = 'left'
		}
		
		if (section.querySelector('h3'))
		{
			section.querySelector('h3').dataset.reveal_from = 'left'
		}
		
		if (section.querySelector('.scroll'))
		{
			section.querySelector('.scroll').dataset.reveal_from = 'left'
			section.querySelector('.scroll').dataset.reveal_delay = '0.16'
		}
		
		if (section.querySelector('.button'))
		{
			section.querySelector('.button').dataset.reveal_from = 'left'
			section.querySelector('.button').dataset.reveal_delay = '0.24'
		}
	}
	else
	{
		section.querySelector('figure').dataset.reveal_from = 'left'
		section.querySelector('.text').dataset.reveal_from = 'right'
		
		if (section.querySelector('section'))
		{
			section.querySelector('section').dataset.reveal_from = 'right'
		}
		
		if (section.querySelector('h2'))
		{
			section.querySelector('h2').dataset.reveal_from = 'right'
		}
		
		if (section.querySelector('h3'))
		{
			section.querySelector('h3').dataset.reveal_from = 'right'
		}
		
		if (section.querySelector('.scroll'))
		{
			section.querySelector('.scroll').dataset.reveal_from = 'right'
			section.querySelector('.scroll').dataset.reveal_delay = '0.16'
		}
		
		if (section.querySelector('.button'))
		{
			section.querySelector('.button').dataset.reveal_from = 'right'
			section.querySelector('.button').dataset.reveal_delay = '0.24'
		}
	}
})

/*document.querySelectorAll('section[data-frontpage]').forEach(section =>
 {
 section.querySelectorAll('.content, figure').forEach(el =>
 {
 el.classList.add('reveal')
 })
 
 section.querySelector('figure').dataset.reveal_from = 'bottom'
 section.querySelector('.content').dataset.reveal_from = 'bottom'
 
 /!*if (section.dataset.Align === 'right')
 {
 section.querySelector('.content').dataset.reveal_from = 'right'
 }
 else
 {
 section.querySelector('.content').dataset.reveal_from = 'left'
 }*!/
 })*/

document.querySelectorAll('section[data-frontpage]').forEach(section =>
{
	section.querySelectorAll('figure').forEach(el =>
	{
		el.classList.add('reveal')
	})
	
	section.querySelector('figure').dataset.reveal_from = 'bottom'
	
	if(isMobile()){
		section.querySelectorAll('.content').forEach(el =>
		{
			el.classList.add('reveal')
		})
		
		section.querySelector('.content').dataset.reveal_from = 'bottom'
	} else {
		gsap.from(section.querySelector('.content'), {
			y: innerHeight,
			scrollTrigger: {
				trigger: section,
				start: 'top bottom',
				end: 'top top',
				scrub: true
			}
		})
	}
})

document.querySelectorAll('section[data-photo_text]').forEach(section =>
{
	section.querySelectorAll('.text, figure').forEach(el =>
	{
		el.classList.add('reveal')
	})
	
	if (section.dataset.Align === 'right')
	{
		section.querySelector('.text').dataset.reveal_from = 'left'
		section.querySelector('figure').dataset.reveal_from = 'right'
	}
	else
	{
		section.querySelector('.text').dataset.reveal_from = 'right'
		section.querySelector('figure').dataset.reveal_from = 'left'
	}
})

document.querySelectorAll('section[data-quote]').forEach(section =>
{
	section.querySelectorAll('.citation, figure').forEach(el =>
	{
		el.classList.add('reveal')
	})
	
	if (section.dataset.Align === 'right')
	{
		section.querySelector('.citation').dataset.reveal_from = 'left'
		section.querySelector('figure').dataset.reveal_from = 'right'
	}
	else
	{
		section.querySelector('.citation').dataset.reveal_from = 'right'
		section.querySelector('figure').dataset.reveal_from = 'left'
	}
})

document.querySelectorAll('section[data-articles]').forEach(section =>
{
	section.querySelectorAll('h2, .col').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-contact]').forEach(section =>
{
	const colLeft = section.querySelector('.col_left')
	const colRight = section.querySelector('.col_right')
	
	colLeft.classList.add('reveal')
	colLeft.dataset.reveal_from = 'left'
	
	colRight.classList.add('reveal')
	colRight.dataset.reveal_from = 'bottom'
})

document.querySelectorAll('section[data-columns]').forEach(section =>
{
	section.querySelectorAll('.col').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-series]').forEach(section =>
{
	section.querySelectorAll('.title, h2, .col').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
	
	section.querySelectorAll('figure').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'scale'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-stories], section[data-expositions]').forEach(section =>
{
	section.querySelectorAll('.title, h2, h3, .col').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
	
	section.querySelectorAll('figure').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'scale'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-blog]').forEach(section =>
{
	section.querySelectorAll('article').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
	
	section.querySelectorAll('figure').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'scale'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-blog_categories]').forEach(section =>
{
	section.classList.add('reveal')
	section.dataset.reveal_from = 'bottom'
	section.dataset.reveal_delay = '0.2'
})

document.querySelectorAll('section[data-post]').forEach(section =>
{
	section.querySelectorAll('h1, .meta, .text').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
	
	section.querySelectorAll('figure').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'scale'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-testimonials]').forEach(section =>
{
	section.querySelectorAll('h2, .slider').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-partenaires]').forEach(section =>
{
	section.querySelectorAll('h2, .slider').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-clients]').forEach(section =>
{
	section.querySelectorAll('h2, .slider, .items').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-temoignages]').forEach((section, index) =>
{
	index = (index === 0) ? index : (index / 15)
	
	section.classList.add('reveal')
	section.dataset.reveal_from = 'bottom'
	section.dataset.reveal_delay = index.toString()
})

document.querySelectorAll('section[data-text]').forEach((section, index) =>
{
	index = (index === 0) ? index : (index / 15)
	
	section.classList.add('reveal')
	section.dataset.reveal_from = 'bottom'
	section.dataset.reveal_delay = index.toString()
})

document.querySelectorAll('section[data-title], section[data-subtitle]').forEach((section, index) =>
{
	index = (index === 0) ? index : (index / 15)
	
	section.classList.add('reveal')
	section.dataset.reveal_from = 'bottom'
	section.dataset.reveal_delay = index.toString()
})

document.querySelectorAll('section[data-photos]').forEach(section =>
{
	section.querySelectorAll('figure').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'scale'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-share]').forEach(section =>
{
	section.querySelectorAll('button').forEach((el, index) =>
	{
		index = (index === 0) ? index : (index / 15)
		
		el.classList.add('reveal')
		el.dataset.reveal_from = 'bottom'
		el.dataset.reveal_delay = index.toString()
	})
})

document.querySelectorAll('section[data-comments]').forEach(section =>
{
	section.classList.add('reveal')
	section.dataset.reveal_from = 'bottom'
})

function animate (el, direction)
{
	direction = direction || 1
	
	const offset = 400
	let x = 0, y = 0, scale = false
	let delay = el.dataset.reveal_delay || 0
	
	if (delay > 0.5)
	{
		delay = 0.5
	}
	
	if (el.dataset.reveal_from === 'left')
	{
		x = -offset
	}
	if (el.dataset.reveal_from === 'right')
	{
		x = offset
	}
	if (el.dataset.reveal_from === 'bottom')
	{
		y = (offset / 3) * direction
	}
	if (el.dataset.reveal_from === 'scale')
	{
		scale = true
	}
	
	gsap.fromTo(el, { x: x, y: y, scale: scale ? 0 : 1, autoAlpha: 0 }, {
		duration: .8,
		delay: delay,
		x: 0,
		y: 0,
		scale: 1,
		autoAlpha: 1,
		ease: Power2.easeOut,
		overwrite: 'auto'
	})
}

function hide (el)
{
	gsap.set(el, { autoAlpha: 0 })
}

gsap.utils.toArray('.reveal').forEach(function (el)
{
	hide(el)
	
	const transition = gsap.getProperty(el, 'transition')
	
	gsap.set(el, {
		transition: 'none'
	})
	
	ScrollTrigger.create({
		trigger: el,
		start: 'top bottom',
		onEnter: (self) =>
		{
			animate(el)
			self.disable()
			
			gsap.set(el, {
				transition: transition,
				delay: 1
			})
		}
	})
})

function getOffset (el)
{
	return {
		x: el.getBoundingClientRect().x + window.scrollX,
		y: el.getBoundingClientRect().y + window.scrollY
	}
}
